/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

const storeMetadata = (state, data) => state.set('data', fromJS(data));

const metadataReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'METADATA_LOADED':
      return storeMetadata(state, action.data);
    default:
      return state;
  }
};

export default metadataReducer;

export const loadMetadataList = (dispatch) => {
  dispatch({ type: 'LOADING_METADATA' });
  RestAPI.get('/metadata/api')
    .then(
      (data) => {
        dispatch({ type: 'METADATA_LOADED', data });
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'METADATA_LOADING_FAILED' });
      }
    );
};
